/**
 * US English (USD) mock schedules for the scheduled-transactions use case.
 * A schedule with both source and destination accounts is a schedule pair,
 * rendered by DoubleRow.
 */

/** @type {Array<import('../../mock-schedules.js').MockSchedule>} */
export const MOCK_SCHEDULES_EN_US = [
	{
		id: 'sch-1',
		nextDate: '2026-08-27',
		transactionType: 'Credit Card Payment',
		estimatedAmount: 1560,
		currencySymbol: '$',
		currencyDecimalPlaces: 2,
		displayAccount: 'Chase Checking',
		displayFreq: 'Monthly',
		description: 'Travel Rewards Card autopay',
	},
	{
		id: 'sch-2',
		nextDate: '2026-08-10',
		transactionType: 'Withdrawal',
		estimatedAmount: 1450,
		currencySymbol: '$',
		currencyDecimalPlaces: 2,
		displayAccount: 'Chase Checking',
		displayFreq: 'Monthly',
		description: 'Mortgage',
	},
	{
		id: 'sch-3',
		nextDate: '2026-08-15',
		transactionType: 'Regular Investment',
		estimatedAmount: 400,
		currencySymbol: '$',
		currencyDecimalPlaces: 2,
		displayAccount: 'Chase Checking',
		displayFreq: 'Monthly',
		description: 'Brokerage top-up',
	},
	{
		id: 'sch-4',
		nextDate: '2026-08-05',
		transactionType: 'Deposit',
		estimatedAmount: 3200,
		currencySymbol: '$',
		currencyDecimalPlaces: 2,
		displayAccount: 'Chase Checking',
		displayFreq: 'Monthly',
		description: 'Salary',
	},
	{
		id: 'sch-5',
		isSchedulePair: true,
		nextDate: '2026-09-01',
		transactionType: 'Transfer',
		estimatedAmount: 500,
		currencySymbol: '$',
		currencyDecimalPlaces: 2,
		displayAccount: 'Chase Checking',
		displaySourceAccount: 'Chase Checking',
		displayDestAccount: 'High-Yield Savings',
		displayFreq: 'Monthly',
		description: 'To savings',
		pairedType: 'Transfer',
		pairedCurrencySymbol: '$',
		pairedCurrencyDecimalPlaces: 2,
	},
];
